import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import history from '../../helpers/history';
import { Layout, PageHeader, Table, Select, Button, Spin, Modal, message } from 'antd';
import moment from 'moment';

import PortfolioResult from './PortfolioResult';

import emitter from '../Evt.js';
import { buffers } from 'redux-saga';

var moment_timezone = require('moment-timezone');

const { Content } = Layout;
const Confirm = Modal.confirm;

var languageMessages = window.appLocale.messages;

function strReplace(source, jsonObjcet) {
    for (var v in jsonObjcet) {
        source = source.replace(v, jsonObjcet[v]);
    }
    return source;
}

class MyPortfolioPage extends Component {
    constructor(props) {
        super(props);

        window.webType === 'US' ? moment_timezone.tz.setDefault("America/New_York") : moment_timezone.tz.setDefault("Asia/Shanghai");

        this.user = {};
        this.state = {
            portfolioItems: [],

            dataSource: [],

            rowId: -1,
            
            statisticsResult: [],

            selectedRowKeys: [],

            spinLoadding: true
        };
    }

    componentDidMount() {
        emitter.addListener('initPage', this.init);
    }

    componentWillMount() {
        this.init();
    }

    componentWillUnmount() {
        emitter.removeListener('initPage', this.init);
    }

    init = () => {
        this.user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};

        var userId = this.user.username === undefined ? '' : this.user.username;
        this.props.dispatch({ type: "action_get_portfolio_items", payload: { u: userId } });
    }

    keepDecimals(value, sign) {
        value = value == null ? '' : value;
        if (value !== '') {
            value = value.replace(/([0-9]+.[0-9]{2})[0-9]*/, "$1");
            value += sign;
        }

        return value;
    }

    setBacktestResult(portfolioItems) {
        var statisticsResult = {};
        var rowId = -1;
        var dataSource = [];
        if (portfolioItems.length > 0) {
            var sequence = 1;
            for (var item in portfolioItems) {
                if (rowId === -1) {
                    rowId = portfolioItems[item].portfolioId;
                    statisticsResult = portfolioItems[item].backtestResult;

                    statisticsResult.portfolioId = portfolioItems[item].portfolioId;
                    statisticsResult.portfolioOptResult = portfolioItems[item].result;
                }
                
                dataSource.push({
                    key: portfolioItems[item].portfolioId,
                    sequence: sequence,
                    created: portfolioItems[item].createDate,
                    fromDate: portfolioItems[item].fromDate,
                    toDate: portfolioItems[item].toDate,
                    barInterval: portfolioItems[item].barInterval,
                    tradePeriod: portfolioItems[item].tradePeriod,
                    status: portfolioItems[item].status
                });

                sequence++;
            }
        }

        return { dataSource, rowId, statisticsResult };
    }

    componentWillReceiveProps(props) {
        var { status, portfolioItems } = props;

        switch (status) {
            case 'get_portfolio_items_success':
                if (portfolioItems !== undefined && portfolioItems.length > 0) {
                    let { dataSource, rowId, statisticsResult } = this.setBacktestResult(portfolioItems);
                    
                    this.setState({ portfolioItems, dataSource, rowId, statisticsResult, spinLoadding: false });
                } else {
                    this.setState({ spinLoadding: false });
                }
                break;
            case 'get_portfolio_items_fail':
                this.setState({ spinLoadding: false });
                break;
            case 'remove_portfolio_success':
                let { selectedRowKeys } = this.state;
                if (selectedRowKeys.length > 0) {

                    var tmpportfolioItems = this.state.portfolioItems.filter(function (e) { return selectedRowKeys.indexOf(e.portfolioId) === -1; });

                    let { dataSource, rowId, statisticsResult } = this.setBacktestResult(tmpportfolioItems);

                    this.setState({ portfolioItems: tmpportfolioItems, dataSource, rowId, statisticsResult, spinLoadding: false });
                }
                message.success(languageMessages['remove.batchbacktest.success']);
                break;
            case 'remove_portfolio_fail':
                this.setState({ spinLoadding: false });
                break;
            default:
                break;
        }
    }

    onRemove = () => {
        var { selectedRowKeys } = this.state;

        if (selectedRowKeys.length > 0) {
            if (this.user.username === undefined) {
                this.props.dispatch({ type: "action_non_user" });
            } else {
                var portfolioIds = selectedRowKeys.join(',');

                var _this = this;
                Confirm({
                    title: languageMessages['want.delete.portfolio'],
                    content: '',
                    okText: languageMessages['yes'],
                    okType: 'danger',
                    cancelText: languageMessages['no'],
                    onOk() {
                        _this.setState({ spinLoadding: true }, () => {
                            _this.props.dispatch({ type: "action_remove_portfolio", payload: { u: _this.user.username, ps: portfolioIds } });
                        });
                    },
                    onCancel() { },
                });
            }
        }
    };

    OnSelectShowChart = (record) => {
        return {
            onClick: () => {
                const { portfolioItems, selectedRowKeys } = this.state;

                var tmpData = portfolioItems.filter(function (e) { return e.portfolioId === record.key; });
                if (tmpData.length > 0) {
                    var statisticsResult = {};
                    if (tmpData[0].backtestResult != null) {
                        statisticsResult = tmpData[0].backtestResult;

                        statisticsResult.portfolioId = tmpData[0].PortfolioId;
                        statisticsResult.portfolioOptResult = tmpData[0].Result;
                    }

                    this.setState({ rowId: record.key, statisticsResult, selectedRowKeys });
                }
            }
        }
    }

    setRowClassName = (record) => {
        return record.key.toString() === this.state.rowId.toString() ? 'common-table-row' : '';
    }

    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys });
    };

    /**
    handleViewPortfolioResult = (record) => {
        console.log(record);
    }
    */

    render() {
        var { dataSource, selectedRowKeys } = this.state;

        const columns = [
            {
                title: languageMessages['sequence'],
                dataIndex: 'sequence',
                align: 'center',
                width: 50
            }, {
                title: languageMessages['created'],
                dataIndex: 'created',
                width: 135,
                sorter: (a, b) => a.created - b.created,
                sortDirections: ['descend', 'ascend']
            }, {
                title: languageMessages['fromDate'],
                dataIndex: 'fromDate',
                width: 90,
                sorter: (a, b) => a.fromDate - b.fromDate,
                sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['toDate'],
                dataIndex: 'toDate',
                width: 90,
                sorter: (a, b) => a.toDate - b.toDate,
                sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['backtestInterval'],
                dataIndex: 'barInterval',
                width: 90,
                sorter: (a, b) => a.barInterval - b.barInterval,
                sortDirections: ['descend', 'ascend']
            }, {
                title: languageMessages['tradePeriod'],
                dataIndex: 'tradePeriod',
                width: 90,
            }, {
                title: languageMessages['status'],
                dataIndex: 'status',
                width: 60,
                sorter: (a, b) => a.status - b.status,
                sortDirections: ['descend', 'ascend']
            },

            /**
            {
                title: languageMessages['control'],
                dataIndex: 'operation',
                //fixed: 'right',
                width: 100,
                render: (text, record) => {
                    return <Button size='small' onClick={() => this.handleViewPortfolioResult(record)}>{languageMessages['view']}</Button>
                }
            }
            */
        ];

        const rowSelection = {
            title: languageMessages['select.all'],
            selectedRowKeys: selectedRowKeys,
            onChange: this.onSelectChange
        }

        return (<Content className='main-container total-content'>
            <Helmet>
                <title>{languageMessages['title']}</title>
                <meta name="keywords" content={languageMessages['keywords']} />
                <meta name="description" content={languageMessages['description']} />

                <meta property="og:title" content={languageMessages['title']} />
                <meta property="og:url" content="https://us.quancept.com/" />
                <meta property="og:type" content="website" />
                <meta name="og:description" content={languageMessages['description']} />

                <meta property="twitter:url" content="https://us.quancept.com/" />
                <meta name="twitter:title" content={languageMessages['title']} />
                <meta name="twitter:description" content={languageMessages['description']} />
                <meta name="twitter:site" content="https://us.quancept.com/" />
            </Helmet>
            <Spin spinning={this.state.spinLoadding}>
                <div className='common-page-header'>
                    <PageHeader title={(<h1>{languageMessages['my.portfolio']}</h1>)} />
                </div>
                <div style={{ padding: '0px 50px' }}>
                    <Layout className='backtest-content'>
                        <div className='common-content'>
                            <div className='common-tools'>
                                <Button onClick={this.onRemove} disabled={selectedRowKeys.length > 0 ? false : true}>{languageMessages['remove']}</Button>
                            </div>
                            <Table size='middle' locale={{ emptyText: ' ' }}
                                columns={columns}
                                dataSource={dataSource}
                                rowSelection={rowSelection}
                                onRow={this.OnSelectShowChart}
                                rowClassName={this.setRowClassName}
                                pagination={false} scroll={{ y: 331 }} />
                        </div>
                    </Layout>
                </div>
                <Content style={{ padding: '0px 50px', marginBottom: '50px' }}>
                    {Object.keys(this.state.statisticsResult).length == 0 || (<PortfolioResult dispatch={this.props.dispatch} status={this.props.status} statisticsResult={this.state.statisticsResult} />)}
                </Content>
            </Spin>
        </Content>);
    }
}

function mapStateToProps(state) {
    return state.portfolio;
}

const page = connect(mapStateToProps)(MyPortfolioPage);
export { page as default }